/**
 * ViewType enum.
 */
export var ViewType;
(function (ViewType) {
    ViewType["NORMAL"] = "NORMAL";
    ViewType["RUN_ON_WORKPLACE_ASSISTANT"] = "RUN_ON_WORKPLACE_ASSISTANT";
    ViewType["WORKPLACE_ASSISTANT"] = "WORKPLACE_ASSISTANT";
})(ViewType || (ViewType = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlld1R5cGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbGliL2VudW1zL1ZpZXdUeXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOztHQUVHO0FBQ0gsTUFBTSxDQUFOLElBQVksUUFJWDtBQUpELFdBQVksUUFBUTtJQUNsQiw2QkFBaUIsQ0FBQTtJQUNqQixxRUFBeUQsQ0FBQTtJQUN6RCx1REFBMkMsQ0FBQTtBQUM3QyxDQUFDLEVBSlcsUUFBUSxLQUFSLFFBQVEsUUFJbkIifQ==